import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclAddressUtilService {

  constructor() { }

  resetAddressData(streetData) {
    streetData.properties.unitNo = '';
    streetData.properties.streetNo = '';
    streetData.properties.street = '';
    streetData.properties.suburb = '';
    streetData.properties.state = '';
    streetData.properties.country = '';
    streetData.properties.postcode = '';
    streetData.properties.locationDescription = '';

    streetData.geometry.coordinates[0] = '';
    streetData.geometry.coordinates[1] = '';
  }

  setAddressData(address, coordinates, resultObj) {
    if (address.unitNo) {resultObj.properties.unitNo = address.unitNo; }

    resultObj.properties.streetNo = address.street_number;
    resultObj.properties.street = address.street_name;
    resultObj.properties.suburb = address.locality;
    resultObj.properties.postcode = address.postal_code;
    resultObj.properties.country = address.country;
    resultObj.properties.state = address.admin_1;

    // var coordinates = tpl.coordinates;
    const lat = parseFloat(coordinates.latitude);
    const lon = parseFloat(coordinates.longitude);
    resultObj.geometry.coordinates[0] = lon;
    resultObj.geometry.coordinates[1] = lat;

    return {obj : resultObj, lat: lat, lon: lon};
  }

}
